import { useUserActions } from '../global-state/user';
import { Icon } from './icon';

export function ContinueWithGoogleButton() {
  const { signInWithOAuth } = useUserActions();
  return (
    <button
      class="button button--google"
      onClick={() => signInWithOAuth({ provider: 'google' })}
    >
      <Icon sprite="google-g" class="w-3.5" />
      <span>Continue with Google</span>
    </button>
  );
}

export function ContinueWithAppleButton() {
  const { signInWithOAuth } = useUserActions();
  return (
    <button
      class="button button--apple"
      onClick={() => signInWithOAuth({ provider: 'apple' })}
    >
      <Icon sprite="apple-logo" class="-mt-[2px] w-3" />
      <span>Continue with Apple</span>
    </button>
  );
}
